import { useState } from "react";
import {
  MDBCard,
  MDBCardHeader,
  MDBCardTitle,
  MDBCardBody,
} from "mdb-react-ui-kit";
import { useRecoilState } from "recoil";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "react-query";
import { errorState, useGameBrandingQuery, useGameDataQuery } from "../settings/Settings.state";
import { Alert, ConfirmationModal, Refresher, SidebarLayout } from "../common";
import AlertDisplay from "../common/AlertDisplay";
import { Button, Col, Row } from "../App.styles";
import { gameBrandingUri } from "../lib/refresh";
import BrandingPreview from "./BrandingPreview";
import BrandingForm from "./BrandingForm";
import BrandingPlaceholder from "./BrandingPlaceholder";
import { getDefaultBrandingPayload } from "./Branding.state";
import { withPlaceholder } from "../common";

const RESET_BRANDING_BODY = "Resetting branding will permanently reset all colors, remove all icons and restore all default branding configuration. It cannot be reversed. Do you wish to proceed?";

const Branding = () => {
  const { t } = useTranslation();
  const useQuery = () => useGameBrandingQuery();
  const { game_id } = useParams();
  const queryClient = useQueryClient();
  const { data } = useGameDataQuery(game_id);
  const { grey_enabled } = data?.game || {};
  const [errorMessage, setErrorMessage] = useState("");
  const [error] = useRecoilState(errorState(game_id));
  const errorFromState = Array.isArray(error) ? error.join(", ") : error;
  const [branding, update, isLoading] = useQuery();
  const [formKey, setFormKey] = useState(`form-key-${Date.now()}`);

  const handleResetBranding = async () => {
    await update(getDefaultBrandingPayload());
    queryClient.invalidateQueries(gameBrandingUri(game_id));
    setFormKey(`form-key-${Date.now()}`);
  };

  return (
    <>
      <AlertDisplay />
      <Row>
        <SidebarLayout message={t("These settings apply to your game You can change them anytime, even during the game.")}>
          {
            (errorFromState || errorMessage) && (
              <Alert color="error">{errorFromState || errorMessage}</Alert>
            )
          }
          <MDBCard>
            <MDBCardHeader>
              <Row>
                <Col>
                  <MDBCardTitle>{t('Game Branding')}</MDBCardTitle>
                </Col>
              </Row>
            </MDBCardHeader>
            <MDBCardBody>
              <BrandingPreview setErrorMessage={setErrorMessage} />
              {grey_enabled && branding && <BrandingForm useQuery={useQuery} key={formKey} />}
              {grey_enabled && branding && (
                <Col className="text-end mt-4">
                  <ConfirmationModal
                    title={t("Reset Branding")}
                    body={t(RESET_BRANDING_BODY)}
                    confirmLabel={t("Reset")}
                    confirmAction={handleResetBranding}
                    isLoading={isLoading}
                  >
                    <Button type="button" className="btn--flat" color="danger">
                      {t("Reset Branding")}
                    </Button>
                  </ConfirmationModal>
                </Col>
              )}
            </MDBCardBody>
          </MDBCard>
        </SidebarLayout>
        <Refresher />
      </Row>
    </>
  );
};

export default withPlaceholder(Branding, BrandingPlaceholder);
